<div class="wrapper" #targetTmp>
  <ng-container *ngTemplateOutlet="template"></ng-container>
</div>

@if (showFullScreenBtn) {
  <button mat-fab color="primary" class="button button--icon button--icon-rounded button--primary fullscreen-button fullscreen-button" aria-label="Full screen" (click)="fullScreenModelToggle()">
    <lib-icon icon="frame-corners" [size]="28"></lib-icon>
  </button>
}

@if (showDownloadBtn) {
  <button mat-fab color="primary" class="button button--icon button--icon-rounded button--primary fullscreen-button download-button" aria-label="Download" (click)="download()" [class.no-transform]="!showFullScreenBtn">
    @if (!isDownloadLoading) {
      <lib-icon icon="download-simple" [size]="28"></lib-icon>
    } @else {
      <mat-spinner mode="indeterminate" class="secondary-progress-spinner-color" diameter="24"></mat-spinner>
    }
  </button>
}

<ng-template #fullscreenTmp>
  <div id="iframe-fullscreen">
    <button mat-fab color="primary" class="button button--icon button--icon-rounded button--primary fullscreen-button fullscreen-button" aria-label="Exit fullscreen" (click)="exitFromFullScreenMode()">
      <lib-icon icon="corners-in" [size]="28"></lib-icon>
    </button>
  </div>
</ng-template>
